import React, { useEffect } from 'react';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useTranslation } from 'react-i18next';
import { Spinner } from '../../../../common';
import {
  useDeleteAttributeUnitMutation,
  useGetAttributeUnitsQuery,
} from '../../../../../redux/services/attributeUnits';
import { UnitsTable } from './UnitsTable';
import { useNavigate } from 'react-router-dom';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

export function UnitsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const { data: units, isLoading, refetch } = useGetAttributeUnitsQuery();
  const [deleteAttributeUnit, { isSuccess }] = useDeleteAttributeUnitMutation();

  useEffect(() => {
    if (isSuccess) {
      showDeleteSuccess();
      refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa jednotiek')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Nová jednotka')}
        createUrl={routes.cmsMeteoStationUnitsCreate}
        permissionsBasic={'meteo-station'}
      />

      <div style={{ margin: '10px' }}>
        <UnitsTable
          units={units}
          onEditClick={(unit) =>
            navigate(routes.cmsMeteoStationUnitsDetail(unit.id))
          }
          onDelete={(unit) => deleteAttributeUnit(unit.id)}
        />
      </div>
    </>
  );
}

export default UnitsPage;
